import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import ajax from '@/utils/ajax';

export interface InsurancePolicyTimelineEvent {
  id: string;
  timestamp: string;
  event_type: string;
  source: string;
  actor_email: string;
  policy_id: string;
  policy_deleted_at?: string | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: Record<string, any>;
}

export interface TimelinePolicy {
  id: string;
  carrier: string | null;
  insurance_provider_name: string | null;
  plan: string | null;
  type: string | null;
  priority_type: string | null;
  subscriber_id: string | null;
  policy_member_id: string | null;
  group_id: string | null;
  healthie_id: number | null;
  plan_start_date: string | null;
  plan_end_date: string | null;
  created_at: string;
  deleted_at: string | null;
  was_discovered: boolean;
  vob_count: number;
  billing_item_count: number;
  claim_count: number;
}

export interface TimelinePriorityConflict {
  priority_type: string;
  policy_ids: string[];
}

export interface TimelineConflicts {
  overlapping_priorities: TimelinePriorityConflict[];
}

export interface InsurancePolicyTimeline {
  policies: TimelinePolicy[];
  conflicts: TimelineConflicts;
  events: InsurancePolicyTimelineEvent[];
}

interface TimelineParams {
  start_date?: string;
  end_date?: string;
}

export const EMPTY_TIMELINE: InsurancePolicyTimeline = {
  policies: [],
  conflicts: { overlapping_priorities: [] },
  events: []
};

export const insurancePolicyTimelineRepository = {
  async getTimelineForPerson({
    host,
    personId,
    params
  }: {
    host: string;
    personId: string;
    params?: TimelineParams;
  }): Promise<InsurancePolicyTimeline> {
    const path = `/api/dugout/insurance_policy_timeline/people/${personId}/insurance-timeline/`;
    const response = await ajax.get({
      url: `${host}${path}`,
      params: { ...params, include: 'policies' }
    });

    return response.data;
  }
};

const InsurancePolicyTimelineRepository = () => {
  const { host } = useContext(AppContext);

  return {
    async getTimelineForPerson(
      personId: string,
      params?: TimelineParams
    ): Promise<InsurancePolicyTimeline> {
      return insurancePolicyTimelineRepository.getTimelineForPerson({ host, personId, params });
    }
  };
};

export default InsurancePolicyTimelineRepository;
